import React, { useEffect, useRef, useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import ArrowTop from "../../../Components/Common/svg/arrowtop";

import TrackingMapGoogle from "../../../Components/map/trackingGooleMap";
import { useMutation, useQuery } from "react-query";
import {
  postDelivery,
  showDelivery,
  updateDelivery,
} from "../../../MyApi/delivery";
import AddressesInfo from "../../../Components/shippings/addresses";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import i18next from "i18next";
import Button from "../../../Components/UI/buttonGlobal";
import { useNavigate } from "react-router-dom";
import { getZones } from "../../../MyApi/zones";
const ShippingStorePage = ({ mode, id }) => {
  const lang = i18next.language;
  const [selectedCodeLang, setSelectedLangCode] = useState("");
  const [storeData, setStoreData] = useState({
    name: "",
    phone: "",
    logo: null,
    commission_amount: "",
    commission_type: "",
    is_active: 1,
    type: "delivery",
    status: "approved",
  });  

  const [addressData, setAddressData] = useState({
    zone_id: null,
    country_id: null,
    governote_id: null,
    city_id: null,
    longitude: "",
    latitude: "",
    address_line_1: "",
  });

  const [area, setArea] = useState([]);
  const prevZoneRef = useRef(null);
  const [locations, setLoactions] = useState([]);

  const { data: zonesData, isLoading: isZonesLoading } = useQuery(
    ["getZones", addressData.city_id],
    () => getZones(lang, addressData.city_id),
    { enabled: !!addressData.city_id },
  );
  console.log("area", area);
  const zones = zonesData?.data?.zones || [];

  useEffect(() => {
    if (locations) {
      setAddressData((prev) => ({
        ...prev,
        latitude: locations.lat,
        longitude: locations.long,
      }));
      //  setLocationError((prev) => ({
      //       ...prev,
      //       location: "",
      //     }));
    }
  }, [locations]);

  useEffect(() => {
    if (!prevZoneRef.current) {
      // first mount (edit load)
      prevZoneRef.current = addressData.zone_id;
      return;
    }

    if (prevZoneRef.current !== addressData.zone_id) {
      // real change by user
      setLoactions(null);
      setAddressData((prev)=>({ ...prev,latitude:null,longitude:null}))
    }

    prevZoneRef.current = addressData.zone_id;
  }, [addressData.zone_id]);

  useEffect(() => {
    const selectedZone =
      zones.find((zone) => zone.id === addressData.zone_id) || [];
    setArea(selectedZone.area);
  }, [addressData.zone_id, zones]);

  const { data: showData } = useQuery(["showDelivery", id], () =>
    showDelivery(id, lang),
  );

  const delivery = showData?.data?.Store || {};
  useEffect(() => {
    if (mode === "edit" && delivery) {
      setStoreData((prev) => ({
        ...prev,
        name: delivery.name,
        phone: delivery.phone,
        logo: delivery.logo,
        is_active: delivery.is_active ? 1 : 0,
        type: "delivery",
        commission_amount: delivery?.commission_amount,
        commission_type: delivery?.commission_type,
        status: delivery.status,
      }));
      setAddressData((prev) => ({
        ...prev,
        zone_id: delivery?.address_data?.zone?.id,
        country_id: delivery?.address_data?.country?.id,
        governote_id: delivery?.address_data?.governorate?.id,
        city_id: delivery?.address_data?.city?.id,
        longitude: delivery?.address_data?.longitude,
        latitude: delivery?.address_data?.latitude,
        address_line_1: delivery?.address_data?.address_line_1,
      }));
    }
  }, [showData]);
  const logoInputRef = useRef(null);
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationKey: ["postDeliveryCompany"],
    mutationFn: (postData) => postDelivery(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      navigate(`${process.env.PUBLIC_URL}/shipping-companies`);
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateDelivery"],
    mutationFn: (postData) => updateDelivery(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const handleUploadClick = () => {
    if (logoInputRef.current) {
      logoInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setStoreData((prev) => ({
      ...prev,
      logo: file,
    }));
  };

  const handleSubmit = () => {
    const formData = new FormData();
    Object.keys(storeData).forEach((key) => {
      if (key === "logo" && !(storeData[key] instanceof File)) {
        return;
      }
      formData.append(`store[${key}]`, storeData[key]);
    });

    Object.keys(addressData).forEach((key) => {
      formData.append(`address[${key}]`, addressData[key]);
    });

    if (mode === "edit") {
      formData.append("lang", selectedCodeLang);
      formData.append("_method", "PUT");
      updateMutation.mutate(formData);
    } else {
      mutation.mutate(formData);
    }
  };

  return (
    <>
      <HeaderBar
        title={mode === "edit" ? "تعديل شركة شحن" : "إضافة شركة شحن جديدة"}
        content={
          mode === "edit" ? "تعديل شركة شحن لدايم" : "أضف شركة شحن جديدة لدايم"
        }
        isBack={true}
        isEdit={mode === "edit"}
        setSelectedLangCode={setSelectedLangCode}
        selectedLangCode={selectedCodeLang}
      />

      <div className="container">
        <div className="card rounded-4">
          <div className="card-body">
            <div className="row add">
              <h6 className="font16 mb-3">معلومات الشركة</h6>

              <div className="col-12 mt-2">
                <label className="form-label">اسم الشركة</label>
                <input
                  type="text"
                  className="form-control"
                  value={storeData.name}
                  onChange={(e) =>
                    setStoreData((prev) => ({ ...prev, name: e.target.value }))
                  }
                />
              </div>

              <div className="col-12 mt-2">
                <label className="form-label">رقم الجوال</label>
                <input
                  type="text"
                  className="form-control"
                  value={storeData.phone}
                  onChange={(e) =>
                    setStoreData((prev) => ({ ...prev, phone: e.target.value }))
                  }
                />
              </div>

              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  نوع العمولة
                </label>
                <select
                  className="form-select"
                  onChange={(e) =>
                    setStoreData((prev) => ({
                      ...prev,
                      commission_type: e.target.value,
                    }))
                  }
                  value={storeData.commission_type}
                >
                  <option>اختر نوع العمولة</option>
                  <option value="subscription">ثابت </option>
                  <option value="commission">نسبة </option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="" className="form-label">
                  نسبة العمولة
                </label>
                <input
                  type="number"
                  value={storeData.commission_amount}
                  className="form-control"
                  onChange={(e) =>
                    setStoreData((prev) => ({
                      ...prev,
                      commission_amount: e.target.value,
                    }))
                  }
                />
              </div>
              <h6 className="form-label mt-2">صورة اللوجو</h6>
              <div
                className="flex-grow-1 border rounded-4 text-center p-4 upload-box mt-4"
                onClick={handleUploadClick}
                style={{ cursor: "pointer", minWidth: "250px" }}
              >
                <ArrowTop />
                <h6 className="fw-bold mb-1">صورة اللوجو</h6>
                <p className="text-muted small mb-0">
                  (JPG / PNG) ارفع صورة بجودة عالية
                </p>
                <p className="text-muted small mb-0">الأبعاد 1:1</p>
                {storeData.logo && (
                  <img
                    src={
                      storeData.logo instanceof File
                        ? URL.createObjectURL(storeData.logo)
                        : storeData.logo
                    }
                    alt=""
                    width={100}
                    height={100}
                  />
                )}
                <input
                  type="file"
                  name="logo"
                  accept="image/png, image/jpeg"
                  hidden
                  ref={logoInputRef}
                  onChange={handleFileChange}
                />

                {storeData.logo && (
                  <p className="mt-2 text-success small">
                    {storeData.logo.name}
                  </p>
                )}
              </div>

              <h6 className="mt-2">العنوان</h6>
              <AddressesInfo
                addressData={addressData}
                setAddressData={setAddressData}
                setArea={setArea}
                area={area}
                zonesData={zonesData}
              />

              <div className="col-12">
                <label>العنوان</label>
                <input
                  type="text"
                  className="form-control"
                  value={addressData.address_line_1}
                  onChange={(e) =>
                    setAddressData((prev) => ({
                      ...prev,
                      address_line_1: e.target.value,
                    }))
                  }
                />
              </div>

              <h6 className="mb-1">اختر الموقع</h6>
              <TrackingMapGoogle
                setLocations={(point) =>
                  setAddressData((prev) => ({
                    ...prev,
                    latitude: point.lat,
                    longitude: point.long,
                  }))
                }
                locations={{
                  lat: addressData.latitude,
                  long: addressData.longitude,
                }}
                area={area}
              />

              <h6 className="fw-bold mb-1 mt-2">الحالة</h6>
              <div className="d-flex justify-content-between align-items-end">
                <div>
                  <h6 className="form-label">حالة الشركة</h6>
                  <p>التحكم في حالة الشركة علي المنصة</p>
                </div>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={storeData.is_active === 1}
                    onChange={(e) =>
                      setStoreData((prev) => ({
                        ...prev,
                        is_active: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              <div className="col-3 mt-3">
                <Button
                  onClick={handleSubmit}
                  label={
                    mode === "edit"
                      ? "تعديل شركة شحن "
                      : "  تأكيد إضافة شركة الشحن"
                  }
                  className={"btn-primary"}
                  isLoading={mutation.isLoading || updateMutation.isLoading}
                  disabled={mutation.isLoading || updateMutation.isLoading}
                ></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShippingStorePage;
